// Build chapter page metadata from chapter data.
// Images are served from public/chapterdata/ as static files.
// Page structure including multi-page spreads is generated by generate_chapters.py

export function buildChaptersWithAssets(baseChapters) {
  return baseChapters.map(ch => {
    // Build page groups from pageFiles metadata
    const groups = (ch.pageFiles || []).map(pageFile => ({
      pages: pageFile.pages,
      images: [`/chapterdata/${ch.folder}/${pageFile.filename}`]
    }));

    return {
      ...ch,
      pages: groups,
      totalPages: ch.totalPages || 0
    };
  });
}


